const ECONOMICS_SECTION = new Set([
  'economics-marketplace',
  'manual-economics',
  'manual-unit-economics',
  'unit-economics',
  'break-even',
  'breakeven',
  'breakeven-options',
]);

const first = (value) => (Array.isArray(value) ? value[0] : value);

export const isManualEconomicsPointer = (value) => ECONOMICS_SECTION.has(
  String(value ?? '').replace(/^#/, '').trim().toLowerCase(),
);

// Bookmarks of /settings/targets. A query or hash that named the manual unit
// economics section opens the Break-even tab; everything else keeps the default tab.
export function settingsTargetsRedirect(to) {
  const path = String(to?.path || '').toLowerCase();
  const bare = path.length > 1 ? path.replace(/\/+$/, '') : path;
  if (bare !== '/settings/targets') return null;

  const query = { ...to.query };
  const hash = String(to.hash || '');
  const hashPoints = isManualEconomicsPointer(hash);
  const queryPoints = ['section', 'anchor', 'tab'].some((key) => isManualEconomicsPointer(first(query[key])));
  if (isManualEconomicsPointer(first(query.section))) delete query.section;
  if (isManualEconomicsPointer(first(query.anchor))) delete query.anchor;
  if (hashPoints || queryPoints) query.tab = 'break-even';

  return {
    name: 'ppc-performance-targets',
    query,
    hash: hashPoints ? '' : hash,
  };
}
